import React from 'react';
import { renderCarousel } from './shared/renderers';

export default function CarouselBlock({ props = {}, theme }) {
  return renderCarousel(props, theme);
}
